export default __webpack_public_path__ + "static/media/menu2.87124624.jpeg";